export default __webpack_public_path__ + "static/media/bankAccount.12dbdd0e.svg";